import {ch, IResponseContainer} from "@renta-apps/athenaeum-react-common";

/**
 * POSTs to an app API endpoint and returns the response value, WITHOUT the athenaeum ApiProvider error handling.
 *
 * ApiProvider.postAsync navigates to the global error page on any failure (error envelope, non-200 status, network error)
 * before the caller's catch block runs. Use this helper only for optional, non-critical data where the caller shows its own error state instead.
 *
 * @throws Error when the request fails, the status is not 200, or the server returns an error envelope.
 */
export async function postWithoutErrorPageAsync<TResponse>(path: string, request: any): Promise<TResponse> {
    const headers = new Headers();
    headers.set("Content-Type", "application/json");

    const xsrfToken: string | null = ch.getXsrfToken();
    if (xsrfToken != null) {
        headers.set("xsrf-token", xsrfToken);
    }

    headers.set("renta-version", ch.version);

    const response: Response = await fetch(path, {
        method: "POST",
        body: JSON.stringify(request ?? {}),
        headers,
        credentials: "include",
    });

    if (!response.ok) {
        throw new Error(`Request to "${path}" failed with status code ${response.status}.`);
    }

    const container = JSON.parse(await response.text()) as IResponseContainer;

    if ((container == null) || (!container.isResponseContainer) || (container.error != null) || (container.unauthorized)) {
        throw new Error(`Request to "${path}" returned an error response.`);
    }

    return container.value as TResponse;
}
